export default "__VITE_ASSET__U$$v9HOj__"